<template>
	<div v-loading="loading" style="width: 100%;height: 100%;z-index: 10;">
		<div v-if="selectdItem.compontChildren[0].data.classfiy.length == 0 && type == 'design'" >请添加商品</div>
		<div style="width: 100%;" v-if="selectdItem.compontChildren[0].data.classfiy.length != 0 && selectdItem.compontChildren[0].preStyle.moduleType == 'list'">
			<div  style="display: flex;align-items: center;justify-content:center">
				<div style="margin: 5px;"
					v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
					:key="classfiyIndex">
					<div @click="tab = classfiyItem.id">
						<div v-show="!selectdItem.compontChildren[0].preStyle.showTitle" style="cursor: pointer;" :style="{color:classfiyItem.id == tab?'#000000':'#b4b4b4 '}">
							{{classfiyItem.description.name}}
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;margin-top: 10px;" v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
				:key="classfiyIndex">
				<!-- <div style="width: 100%;" v-if="goodsListObj[classfiyItem.id] && classfiyItem.id == tab">
					<div :style="getColumns()" style="width: 100%;display: grid;margin-top: 5px;justify-content: space-around;">
						<single-goods style="width: 100%;" v-for="(item,index) in goodsListObj[classfiyItem.id]" :key="index"  :goodsData="item" :equipment="equipment" :selectdItem="selectdItem"
							:systemConfig="systemConfig" :type="type"></single-goods>
					</div>
				</div> -->
				<div :style="{'grid-template-columns':equipment == 'pc'?`repeat(auto-fill, ${selectdItem.compontChildren[0].preStyle.showModuleWidthHeightPre?selectdItem.compontChildren[0].preStyle.moduleWidthHeightPre + '%':selectdItem.compontChildren[0].preStyle.moduleWidthHeight + 'px'})`:'repeat(auto-fill, 48%)'}"
					style="display: grid;justify-content: space-between;"
					v-if="goodsListObj[classfiyItem.id] && classfiyItem.id == tab">
					<div @click="navTo(item.url_name)" :style="{'--hover': compontentStyle.hoverColor}" class="linktit" style="cursor: pointer;margin-top: 10px;width: 94%;margin: auto;"
						v-for="(item,index) in goodsListObj[classfiyItem.id]" :key="index">
						<div style="width: 100%; aspect-ratio: 16/16;">
							<img :style="{width:equipment == 'pc'?'100%':'100%'}" style="height: 100%;"
								:src="getImg(item)" />
						</div>
						<div v-if="!selectdItem.compontChildren[0].preStyle.showNamePrice" :style="{width:equipment == 'pc'?'100%':'100%'}"
							style="overflow: hidden;text-overflow:ellipsis; white-space: nowrap;margin-top: 12px;text-align: center;">
							{{item.name}}
						</div>
						<div v-if="!selectdItem.compontChildren[0].preStyle.showNamePrice" :style="{width:equipment == 'pc'?'100%':'100%'}"
							style="display: flex;justify-content: center;margin-top: 12px;align-items: center;">
							<div :style="{
								color:selectdItem.compontChildren[0].preStyle.border.color
							}" >
								{{item.price}}
							</div>
							<div
								v-if="item.origin_price"
								style="margin-left: 20px; text-decoration: line-through;color: #acacac ;">
								{{item.origin_price}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 100%;" v-if="selectdItem.compontChildren[0].data.classfiy.length != 0  && selectdItem.compontChildren[0].preStyle.moduleType == 'scroll'">
			<div  style="display: flex;align-items: center;justify-content:center">
				<div style="margin: 5px;"
					v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
					:key="classfiyIndex">
					<div @click="tab = classfiyItem.id">
						<div  v-show="!selectdItem.compontChildren[0].preStyle.showTitle" style="cursor: pointer;" :style="{color:classfiyItem.id == tab?'#000000':'#b4b4b4 '}">
							{{classfiyItem.description.name}}
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 100%;margin-top: 10px;" v-for="(classfiyItem,classfiyIndex) in selectdItem.compontChildren[0].data.classfiy"
				:key="classfiyIndex">
				<PreciseDragScroll  style="height: 100%;width: 100%;"  :equipment="equipment" v-if="goodsListObj[classfiyItem.id] && classfiyItem.id == tab">
					<div  @click="navTo(item.id)" :style="{width:equipment == 'pc'?selectdItem.compontChildren[0].preStyle.moduleWidthHeight + 'px':'120px','--hover': compontentStyle.hoverColor}" style="cursor: pointer;margin-left: 10px;"
						v-for="(item,index) in goodsListObj[classfiyItem.id]" :key="index"  class="linktit">
						<div style="width: 100%; aspect-ratio: 16/16;">
							<img :style="{width:equipment == 'pc'?'100%':'100%'}" style="height: 100%;"
								:src="getImg(item)" />
						</div>
						<div v-if="!selectdItem.compontChildren[0].preStyle.showNamePrice" :style="{width:equipment == 'pc'?'100%':'100%'}"
							style="overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
							{{item.name}}
						</div>
						<div v-if="!selectdItem.compontChildren[0].preStyle.showNamePrice" :style="{width:equipment == 'pc'?'100%':'100%'}"
							style="display: flex;justify-content: center;align-items: center;">
							<div style="color: #5555ff ;">
								{{item.price}}
							</div>
							<div
								v-if="item.origin_price"
								style="margin-left: 20px; text-decoration: line-through;color: #acacac ;">
								{{item.origin_price}}
							</div>
						</div>
					</div>
				</PreciseDragScroll>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		getAutocomplete
	} from '../../api/all.js'
	import {
		getCategories,
		getDesignGetProducts,
		getProducts,
		getFrontCategories,
		getDesignGetCategories,
		getDesignProducts
	} from '../../api/all.js'
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import PreciseDragScroll from './PreciseDragScroll.vue'
	
	import singleGoods from './singleGoods.vue'
	
	export default {
		components: {
			PreciseDragScroll,
			singleGoods
		},
		//  数据获取从 vuex 获取
		props: {
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		data() {
			return {
				
				selectList: [],
				loading: false,
				goodsListObj: {},
				tab: '',
				textValue: "",
				editableTabsValue: "",
				form: {
					list: [{
							language: "zh_cn",
							languageName: "中文",
							text: ""
						},
						{
							language: "en",
							languageName: "英文",
							text: ""
						}
					],
					classfiy: [{
						name: "tabs1",
						goodsList: []
					}],
				}
			}
		},
		computed: {
			...mapState("lowCodeStore", ['products', 'mapGoodsListObj']),
		},
		watch: {
			equipment: {
				handler: function(newV, oldV) {
					console.log('equipment', newV)
				},
			},
			selectdItem: {
				handler: async function(newV, oldV) {
					let that = this
					if (this.type != 'build') {
						console.log('mountedthis.type selectdItem', newV)
						newV.compontChildren[0].data.classfiy.forEach(async classifyItem => {
							if (this.mapGoodsListObj[classifyItem.id]) {
							} else {
								let wsid = that.$cookies.get("wsid")
								let products = await getDesignProducts({
									wsid,
									id: classifyItem.id,
								})
								this.setMapGoodsListObj({
									id: classifyItem.id,
									list: products.data.data
								})
							}
							this.goodsListObj[classifyItem.id] = []
							this.mapGoodsListObj[classifyItem.id].forEach(product => {
								if (classifyItem.selectListIds.indexOf(product.id) != -1) {
									this.goodsListObj[classifyItem.id].push(product)
								}
							})
							if (newV.compontChildren[0].data.classfiy.length > 0 && !this.tab) {
								this.tab = newV.compontChildren[0].data.classfiy[0].id
							}
						})

						this.$forceUpdate()
					}
				},
				immediate: true,
				deep: true
			}
		},
		async mounted() {
			let that = this
			console.log('mounted this.type', this.type)
			if (this.type != 'build') {
			
			} else {
				this.selectdItem.compontChildren[0].data.classfiy.forEach(async item => {
					this.goodsListObj[item.id] = item.selectList
					if (this.selectdItem.compontChildren[0].data.classfiy.length > 0) {
						this.tab = this.selectdItem.compontChildren[0].data.classfiy[0].id
					}
					this.$forceUpdate()
				})
				console.log('this.goodsListObj', this.goodsListObj)
			}
		},
		methods: {
			getColumns() {
				let num = 1
				if(this.equipment == 'pc'){
					num = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.pcNum
				}else{
					num = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneNum
				}
				return {
					gridRowGap:this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.rowGap + 'px',
					gridColumnGap:this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap + 'px',
					gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap}px))`
				}
			},
			
			...mapMutations("lowCodeStore", ["setList", "setMapGoodsListObj"]),
			getCurrenyCode() {
				let currency = this.systemConfig.currency
				console.log(currency)
				let map = {
					USD: '$',
					CNY: '￥',
					EUR: '€',
					JYP: '¥'
				}
				console.log(map[currency])
				return map[currency]
			},
			getImg(item) {
				console.log('item123', item)
				console.log('process.env.IMG_URL + item.image', process.env.VUE_APP_IMG_URL + item.image)
				if (this.type != 'build') {
					return process.env.VUE_APP_IMG_URL + item.image
				} else {
					return process.env.VUE_APP_IMG_URL + item.image
				}
			},
			getLanguage(item) {
				console.log('item', item)
				let str = ''
				item.descriptions.forEach(item => {
					if (item.locale == this.systemConfig.locale) {
						str = item.name
					}
				})
				return str
			},
			changeTab() {

			},
			navTo(id) {
				if (this.type == 'design') {
					return
				}
				console.log('navTo', id)
				this.$router.push({
					path: '/products/' + id
				})
				// window.location.reload()
				// window.location.href = 'https://www.ggyykk111.shop/products/' + id
			},
			handleTabsEdit() {}

		}
	}
</script>

<style scoped>
	.app-container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 20px;
	}

	.item-card {
		display: inline-flex;
		width: 200px;
		height: 150px;
		margin-right: 16px;
		flex-shrink: 0;
	}

	.card-content {
		width: 100%;
		height: 100%;
		background: #fff;
		border-radius: 8px;
		padding: 16px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		border: 1px solid #eee;
	}

	.card-title {
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 8px;
		color: #333;
	}

	.card-desc {
		font-size: 14px;
		color: #666;
		line-height: 1.4;
	}
	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}
</style>